import React from "react";
import Banners from "./Banners";
import LevelDeck from "./LevelDeck";

/**
 * Главный экран кабинета.
 *
 * Максим 22.08.2026: сверху два информационных баннера, содержимое которых
 * он меняет по обстоятельствам; ниже — уровни с дорожной картой заданий.
 *
 * Отдельной ленты шагов знакомства больше нет: она слилась с первым уровнем
 * «Первые шаги». Так у новичка остаётся подсказка, что делать, но на экране
 * не два разных списка дел, между которыми надо выбирать.
 */

const HomePage = () => (
  <div className="fw-page">
    <Banners />
    <LevelDeck />
  </div>
);

export default HomePage;
